import { PageHeader, Tabs, Row, Col, Modal, Space, message, Spin, Select } from "antd";
import React, { Component } from "react";
import { tabStyles } from "../../../../Components/TabbedDynamicTable";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputItem,
  TextAreaItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  ButtonItem,
  DynamicCardForm,
} from "../../../../Components/Items";
import { PlusOutlined, DeleteOutlined, CopyOutlined, SaveOutlined, ArrowLeftOutlined,EditOutlined, FilePdfOutlined} from "@ant-design/icons";
import ModalPlantillaProceso from "../Modales/ModalPlantillaProceso";
import ModalPdfPrograma from "../Modales/ModalPdfPrograma";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import ProcesoForm from "../ProcesoForm/ProcesoForm";
import moment from "moment";

const { TabPane } = Tabs;
const { Option } = Select;

class VistaPrograma extends Component {
  programaFormRef = React.createRef();
  procesoFormRefs = {};

  state = {
    loading: false,
    guardando: false,
    cargandoDatos: false,
    procesos: [],
    activeProcesoTab: null,
    modalPlantillaProceso: false,
    objetoProyectos: [],
    // Para el modal de ver pdf
    modalPdf: false,
    programaIdPdf: null,
  };

  get modo() {
    return this.props.location?.state?.modo || "agregar";
  }

  get programaId() {
    return this.props.location?.state?.id || null;
  }

  componentDidMount() {
    this.cargarProyectos();
    if (this.programaId) {
      this.cargarPrograma();
    }
  }

  cargarProyectos() {
    axios
      .post("proyectos/selectProyectos", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
  }

  cargarPrograma() {
    this.setState({ cargandoDatos: true });
    axios
      .post("programa/datosPrograma", { empresaId: this.props.empresaId, programaId: this.programaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          const data = res.data.data;

          if (data.fecha) data.fecha = moment(data.fecha);

          if (this.programaFormRef.current) {
            this.programaFormRef.current.setFieldsValue(data);
          }
          const procesosCargados = (data.procesos || []).map(proc => ({
            ...proc,
            _key: proc._id || Date.now() + Math.random()
          }));

          this.setState({
            procesos: procesosCargados,
            activeProcesoTab: procesosCargados.length > 0 ? String(procesosCargados[0]._key) : null
          });

        } else {
          message.error("Error al cargar el programa");
          this.props.history.goBack();
        }
      })
      .catch(() => {
        message.error("Error de conexión");
        this.props.history.goBack();
      })
      .finally(() => this.setState({ cargandoDatos: false }));
  }

  agregarProceso(plantilla = null) {
    const key = Date.now();
    const nuevoProceso = plantilla
      ? {
          ...plantilla,
          _key: key,
          derivadoDe: plantilla._id,
          derivadoDeNombre: plantilla.nombre,
          esPlantilla: false, 
          version: "",
          _id: undefined 
        }
      : { _key: key, nombre: `Proceso ${this.state.procesos.length + 1}` };
    
    this.setState((prev) => ({
      procesos: [...prev.procesos, nuevoProceso],
      activeProcesoTab: String(key),
      modalPlantillaProceso: false,
    }));
  }

  actualizarNombreProceso(key, nombre) {
    this.setState((prev) => ({
      procesos: prev.procesos.map((p) =>
        p._key === key ? { ...p, nombre } : p
      ),
    }));
  }

  eliminarProceso(key) {
    this.setState((prev) => {
      const procesos = prev.procesos.filter((p) => p._key !== key);
      delete this.procesoFormRefs[key];
      const activeProcesoTab = procesos.length > 0 ? String(procesos[procesos.length - 1]._key) : null;
      return { procesos, activeProcesoTab };
    });
  }

  onEditTab(targetKey, action) {
    if (action === "remove") {
      Modal.confirm({
        title: "¿Eliminar este proceso?",
        content: "Se eliminará el proceso y todos sus puntos.",
        okText: "Eliminar",
        okType: "danger",
        cancelText: "Cancelar",
        onOk: () => this.eliminarProceso(Number(targetKey) || targetKey),
      });
    }
  }

  abrirModalPlantillasProceso() {
    this.setState({ modalPlantillaProceso: true });
  }

  async guardar() {
    let programaValues;
    try {
      programaValues = await this.programaFormRef.current.validateFields();
    } catch {
      message.error("Revisa los campos requeridos del programa");
      return;
    }
    const programaConId = this.programaId
    ? { ...programaValues, _id: this.programaId }
    : programaValues;

    const procesoDataPromises = this.state.procesos.map((proc) => {
      const ref = this.procesoFormRefs[proc._key];
      if (ref && ref.getData) {
        return ref.getData()
          .then(data => ({ ...data.proceso, _id: proc._id }))
          .catch(() => {
            message.error(`Error en el proceso: ${proc.nombre}. Revisa sus campos.`);
            return Promise.reject();
          });
      }
      return Promise.resolve(null);
    });

    let procesosData;
    try {
      procesosData = await Promise.all(procesoDataPromises);
    } catch {
      return;
    }

    procesosData = procesosData.filter(p => p !== null);
    const payload = {
      empresaId: this.props.empresaId,
      usuarioId: this.props.usuarioId,
      programa: programaConId,
      procesos: procesosData.filter(p => p !== null),
    };

    this.setState({ guardando: true });
    axios
      .post("programa/guardarPrograma", payload, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          message.success(this.modo === "editar" ? "Programa actualizado" : "Programa guardado");
          this.props.history.push("/panel/calidad");
        } else {
          message.error(res.data.message || "Error al guardar el programa");
        }
      })
      .catch(() => message.error("Error de conexión"))
      .finally(() => this.setState({ guardando: false }));
  }

  render() {
    const { guardando, cargandoDatos, procesos, activeProcesoTab, modalPlantillaProceso, objetoProyectos } = this.state;
    const modo = this.modo;
    const disabled = modo === "ver";

    const cprog = this.props.camposCalidad?.programa ?? {};
    const showDuracionEstimada = cprog.duracionEstimada !== false;
    const showMetadatos        = cprog.metadatos        !== false;

    const titulos = {
      agregar: "Agregar Programa",
      editar: "Editar Programa",
      ver: "Ver Programa",
    };

    return (
      <Spin spinning={guardando || cargandoDatos}>
        <style>{tabStyles}</style>
        <PageHeader
          title={titulos[modo] || "Programa"}
          onBack={() => this.props.history.goBack()}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            !disabled
              ? [
                  <ButtonItem key="guardar" verde className="botonAgregar" type="primary" icon={<SaveOutlined />} loading={guardando} onClick={() => this.guardar()}>
                    {modo === "editar" ? "Guardar Cambios" : "Guardar Programa"}
                  </ButtonItem>,
                ]
              : [
                  <ButtonItem
                    key="editar"
                    icon={<EditOutlined />}
                    verde
                    className="botonAgregar"
                    onClick={() =>
                      this.props.history.replace("/panel/programa", {
                        id: this.programaId,
                        modo: "editar",
                      })
                    }
                  >
                    Editar
                  </ButtonItem>,
                ]
          }
        />
        <div style={{ borderRadius: '8px', backgroundColor: "white", padding: "20px" }}>
          <Form ref={this.programaFormRef} layout="vertical">
            <Row gutter={24}>
              <Col span={12}>
                <DynamicCardForm title="Datos del Programa" span={24}>
                  <Row gutter={16}>
                    <Col span={12}>
                      <FormItem label="Nombre" name="nombre" required labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <InputItem placeholder="Nombre del programa" disabled={disabled} />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Supervisor" name="supervisorId" required labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <SelectEmpleadosItem
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                          placeholder="Seleccionar supervisor"
                          disabled={disabled}
                        />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Cliente" name="clienteId" required labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <SelectClientesItem
                          empresaId={this.props.empresaId}
                          headersToken={this.props.headersToken}
                          placeholder="Seleccionar cliente"
                          disabled={disabled}
                        />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem label="Proyecto" name="proyectoId" required labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <SelectItem placeholder="Seleccionar proyecto" disabled={disabled}>
                          {objetoProyectos}
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={24}>
                      <FormItem label="Descripción" name="descripcion" required labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <TextAreaItem rows={2} disabled={disabled} />
                      </FormItem>
                    </Col>
                    <Col span={24}>
                      <FormItem label="Observaciones" name="observaciones" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                        <TextAreaItem rows={2} disabled={disabled} />
                      </FormItem>
                    </Col>
                  </Row>
                </DynamicCardForm>
              </Col>

              <Col span={12}>
                <DynamicCardForm title="Fechas y Duración" span={24}>
                  <Row gutter={16}>
                    <Col span={12}>
                      <FormItem label="Fecha del Programa" name="fecha" required labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                        <DatePickerItem style={{ width: "100%" }} placeholder="Seleccionar fecha" disabled={disabled} />
                      </FormItem>
                    </Col>
                    {showDuracionEstimada && (
                      <Col span={12}>
                        <FormItem label="Duración Estimada (Días)" name="duracionEstimada" labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                          <InputNumberItem min={1} placeholder="Ej. 5" style={{ width: "100%" }} disabled={disabled} />
                        </FormItem>
                      </Col>
                    )}
                    {showMetadatos && (
                      <Col span={12}>
                        <FormItem label="Tipo de industria" name={["metadatos", "tipoIndustria"]} labelCol={{ span: 12 }} wrapperCol={{ span: 12 }}>
                          <InputItem placeholder="Ej. manufactura, salud…" disabled={disabled} />
                        </FormItem>
                      </Col>
                    )}
                    <Col span={12}></Col>
                  </Row>
                </DynamicCardForm>

                <DynamicCardForm title="Colaboradores" span={24}>
                  <Form.List name="colaboradores">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((field) => (
                          <Row gutter={8} key={field.key} style={{ marginBottom: 8 }}>
                            <Col span={12}>
                              <FormItem name={[field.name, "empleadoId"]} required wrapperCol = {12} labelCol ={12}>
                                <SelectEmpleadosItem
                                  empresaId={this.props.empresaId}
                                  headersToken={this.props.headersToken}
                                  placeholder="Empleado"
                                  disabled={disabled}
                                />
                              </FormItem>
                            </Col>
                            <Col span={8}>
                              <FormItem name={[field.name, "rol"]} wrapperCol = {12} labelCol ={12}>
                                <InputItem placeholder="Rol" disabled={disabled} />
                              </FormItem>
                            </Col>
                            {!disabled && (
                              <Col span={4}>
                                <ButtonItem danger size="small" icon={<DeleteOutlined />} onClick={() => remove(field.name)} />
                              </Col>
                            )}
                          </Row>
                        ))}
                        {!disabled && (
                          <ButtonItem icon={<PlusOutlined />} size="small" onClick={() => add()}>
                            Agregar Colaborador
                          </ButtonItem>
                        )}
                      </>
                    )}
                  </Form.List>
                </DynamicCardForm>
              </Col>
            </Row>

            <Row gutter={24}>
              <DynamicCardForm title="Procesos del Programa" span={24}>
                {procesos.length === 0 ? (
                  <p style={{ color: "#999", textAlign: "center", margin: "16px 0" }}>
                    No hay procesos. Agrega uno para comenzar.
                  </p>
                ) : (
                  <Tabs
                    type="editable-card"
                    activeKey={activeProcesoTab}
                    onChange={(key) => this.setState({ activeProcesoTab: key })}
                    onEdit={disabled ? undefined : this.onEditTab.bind(this)}
                    hideAdd
                    className="custom-tabs"
                  >
                    {procesos.map((proc) => (
                      <TabPane
                        tab={
                          <span>
                            {proc.nombre || `Proceso ${proc._key}`}
                          </span>
                        }
                        key={String(proc._key)}
                        forceRender={true}
                        closable={!disabled}
                      >
                        <ProcesoForm
                          ref={(ref) => { if (ref) this.procesoFormRefs[proc._key] = ref; }}
                          initialValues={proc}
                          disabled={disabled}
                          onNombreChange={(nombre) => this.actualizarNombreProceso(proc._key, nombre)}
                        />
                      </TabPane>
                    ))}
                  </Tabs>
                )}
                {!disabled && (
                  <Space style={{ marginTop: 12 }}>
                    <ButtonItem icon={<PlusOutlined />} onClick={() => this.agregarProceso()}>
                      Agregar Proceso en blanco
                    </ButtonItem>
                    <ButtonItem icon={<CopyOutlined />} onClick={() => this.abrirModalPlantillasProceso()}>
                      Usar Plantilla de Proceso
                    </ButtonItem>
                  </Space>
                )}
              </DynamicCardForm>
            </Row>
          </Form>
          <div style={{ textAlign: "right", marginTop: 16 }}>
            <Space>
              <ButtonItem icon={<ArrowLeftOutlined />} danger onClick={() => this.props.history.goBack()}>
                {disabled ? "Regresar" : "Cancelar"}
              </ButtonItem>
              {modo === "ver" ? 
                <ButtonItem icon={<FilePdfOutlined />} onClick={() => this.setState({ modalPdf: true, programaIdPdf: this.props.location?.state?.id  })} > Ver PDF</ButtonItem>
                : null
              }
              {!disabled && (
                <ButtonItem type="primary" icon={<SaveOutlined />} verde loading={guardando} onClick={() => this.guardar()}>
                  {modo === "editar" ? "Guardar Cambios" : "Guardar Programa"}
                </ButtonItem>
              )}
            </Space>
          </div>
        </div>
        
        <ModalPlantillaProceso
          visible={modalPlantillaProceso}
          onCancel={() => this.setState({ modalPlantillaProceso: false })}
          onUsar={(plantilla) => this.agregarProceso(plantilla)}
        />
        <ModalPdfPrograma
          visible={this.state.modalPdf}
          programaId={this.state.programaIdPdf}
          onCancel={() => this.setState({ modalPdf: false, programaIdPdf: null })}
        />
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
  camposCalidad: state.empresa.camposCalidad,
});

export default connect(mapStateToProps)(VistaPrograma);